let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lNmLa")).then(() => parcelRequire('7juh5'));